module.exports = __webpack_public_path__ + "media/images/ff_camera_icon-5e45d642cbe8ad7ba9f314aecf059857.png";